import { Box, Tab, TabProps } from '@chakra-ui/react'

interface OrderTypeTabProps extends TabProps {
  title: string
  counter?: number
  isSelected?: boolean
  isStart?: boolean
  isEnd?: boolean
}

export default function OrderTypeTab({
  title,
  counter,
  isSelected,
  isStart,
  isEnd,
  ...tabProps
}: OrderTypeTabProps) {
  return (
    <Tab
      minW={{ base: 24, sm: 32, md: 32, lg: 40 }}
      p={{ base: 3, md: 4 }}
      fontSize={'sm'}
      fontWeight={isSelected ? 'bold' : 500}
      border="1px solid rgba(255, 255, 255, 0.1)"
      borderRadius="xl"
      borderLeftRadius={isStart ? 'xl' : 0}
      borderRightRadius={isEnd ? 'xl' : 0}
      background="dark"
      color="gray.500"
      pos="relative"
      overflow="hidden"
      _selected={{
        color: 'white',
        background: '#1F2546',
      }}
      _focus={{ boxShadow: 'none' }}
      {...tabProps}
    >
      {title} {counter && counter > 0 ? `(${counter})` : ''}
      {isSelected && (
        <Box
          bg="linear-gradient(90deg, #467EE5, #FF4E70)"
          pos="absolute"
          left={0}
          right={0}
          bottom={0}
          h={1}
          borderRadius="xl"
          borderLeftRadius={isStart ? 'xl' : 0}
          borderRightRadius={isEnd ? 'xl' : 0}
        />
      )}
    </Tab>
  )
}
